import { trayListApi } from "../../../../redux/apis/tray-api";
import { appendPage, failureMessage } from "./tray-list-state";

// Same cap as the backend's MAX_TRAY_PAGE_SIZE (trayValidation.ts) — keep them in step.
export const TRAY_LIST_MAX_PAGE_SIZE = 100;

/**
 * Every tray in a tab (and search), fetched a full page at a time — for
 * "Select all N trays", where only the first pages are loaded on screen.
 * Stops at the server's total, or when a page adds nothing new (offsets can
 * shift while trays are added or inactivated). Rejects on the first failure,
 * with the server's message when it refused the page.
 */
export async function loadAllTrays({ status, searchValue }) {
  let trays = [];
  for (let pageNumber = 1; ; pageNumber += 1) {
    const res = await trayListApi({
      pageNumber,
      pageSize: TRAY_LIST_MAX_PAGE_SIZE,
      status,
      searchValue,
    });
    const failed = failureMessage(res);
    if (failed) throw new Error(failed);
    const data = res?.data?.data ?? {};
    const rows = Array.isArray(data.trays) ? data.trays : [];
    const merged = appendPage(trays, rows);
    const added = merged.length - trays.length;
    trays = merged;
    const total = Number(data.totalCount) || 0;
    if (added === 0 || rows.length < TRAY_LIST_MAX_PAGE_SIZE || trays.length >= total) {
      return trays;
    }
  }
}
